import React, { FC, useState } from 'react';
import { ReportErrorModal } from './Components/ReportErrorModal';
import { StreamLineIcon } from '../../../../SvgIcon/StreamLineIcon';
import { useInsuranceLabels } from '../../../Utils/Context/labelsContext';

export const ReportErrorBar: FC = () => {
  const [isModalOpened, setIsModalOpened] = useState<boolean>(false);
  const {
    headings,
  } = useInsuranceLabels();
  return (
    <div className="reportErrorBar">
      <button
        type="button"
        aria-haspopup
        aria-expanded={isModalOpened}
        onClick={() => setIsModalOpened(true)}
        className="reportErrorBar__button"
      >
        <span>{headings.reportErrorBarHeading}</span>
        <span className="reportErrorBar__boldText">{headings.reportErrorBarSubHeading}</span>
        <StreamLineIcon iconName="s-mail" className="reportErrorBar__icon" />
      </button>
      {isModalOpened && (
        <ReportErrorModal
          onClose={() => setIsModalOpened(false)}
        />
      )}
    </div>
  )
};
